import { useState } from "react";
import { toast } from "sonner";
import { Sparkles, Loader2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { streamSSE } from "@/lib/stream";
import { useApi } from "@/lib/api";

const SUGGESTIONS = ["Ricordagli i documenti mancanti", "Proponi un appuntamento", "Fai gli auguri", "Proponi il rinnovo"];

const parseEmail = (t) => {
  const m = t.match(/^\s*OGGETTO:\s*(.*)\n?([\s\S]*)$/i);
  if (m) return { subject: m[1].trim(), body: m[2].replace(/^\s*\n/, "") };
  return /^\s*O(G(G(E(T(T(O(:)?)?)?)?)?)?)?$/i.test(t) ? { subject: "", body: "" } : { subject: "", body: t };
};

export const AiDraft = ({ clientId, onDraft }) => {
  const [goal, setGoal] = useState("");
  const [busy, setBusy] = useState(null);
  const { data: st } = useApi("/settings");

  const run = async (channel) => {
    setBusy(channel);
    try {
      await streamSSE("/ai/draft", { client_id: clientId, channel, goal }, (full) => {
        const d = channel === "email" ? parseEmail(full) : { subject: null, body: full };
        onDraft(d.subject, d.body);
      });
      toast.success("Bozza pronta: controllala prima di inviare");
    } catch (e) { toast.error(e.message); } finally { setBusy(null); }
  };

  if (st?.ai_enabled === false) return null;
  return (
    <div className="rounded-xl border border-violet-200 bg-violet-50/50 p-4 space-y-3" data-testid="ai-draft">
      <p className="text-sm font-medium flex items-center gap-2 text-violet-800"><Sparkles className="h-4 w-4" />Scrivi con l'AI</p>
      <Input data-testid="ai-draft-goal" value={goal} onChange={(e) => setGoal(e.target.value)} className="bg-white"
        placeholder="Cosa vuoi dire? (es. chiedere la busta paga per il prestito)" />
      <div className="flex flex-wrap gap-1.5">
        {SUGGESTIONS.map((s) => (
          <button key={s} type="button" onClick={() => setGoal(s)} className="text-xs px-2.5 py-1 rounded-full bg-white border border-violet-200 hover:border-violet-400">{s}</button>
        ))}
      </div>
      <div className="grid grid-cols-2 gap-2">
        <button data-testid="ai-draft-email-btn" disabled={!!busy} onClick={() => run("email")}
          className="flex items-center justify-center gap-2 rounded-lg px-3 py-2 text-sm font-medium bg-violet-600 text-white hover:bg-violet-700 disabled:opacity-50">
          {busy === "email" ? <Loader2 className="h-4 w-4 animate-spin" /> : <Sparkles className="h-4 w-4" />}Bozza email
        </button>
        <button data-testid="ai-draft-wa-btn" disabled={!!busy} onClick={() => run("whatsapp")}
          className="flex items-center justify-center gap-2 rounded-lg px-3 py-2 text-sm font-medium border border-violet-300 text-violet-800 bg-white hover:bg-violet-50 disabled:opacity-50">
          {busy === "whatsapp" ? <Loader2 className="h-4 w-4 animate-spin" /> : <Sparkles className="h-4 w-4" />}Bozza WhatsApp/SMS
        </button>
      </div>
    </div>
  );
};
